const cb150xData = {
  slug: "cb150x",
  name: "Honda CB150X",

  hero: {
    shortDescription:
      "Motor sport adventure 150cc dengan desain tangguh dan kenyamanan optimal untuk perjalanan jauh",

    variants: [
      {
        key: "volcano-black",
        label: "Special",
        fullName: "Honda CB150X Volcano Matte Black",
        startPrice: 35724000,
      },
      {
        key: "mandala-red",
        label: "STD",
        fullName: "Honda CB150X STD Mandala Red",
        startPrice: 35214000,
      },
      {
        key: "amazon-green",
        label: "STD",
        fullName: "Honda CB150X STD Amazon Matte Green",
        startPrice: 35214000,
      },
    ],

    slides: [
      {
        variantKey: "volcano-black",
        image: "/assets/motor/produk/cb150x/Honda-CB150X-Volcano-Matte-Black-580x380_c.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "mandala-red",
        image: "/assets/motor/produk/cb150x/Honda-CB150X-Mandala-Red-580x380_c.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "amazon-green",
        image: "/assets/motor/produk/cb150x/Honda-CB150X-Amazon-Matte-Green-580x380_c.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CB150X merupakan motor sport adventure yang dirancang untuk pengendara yang menginginkan kenyamanan berkendara jarak jauh dengan karakter mesin bertenaga dan desain tangguh.",
      },
      {
        type: "paragraph",
        text:
          "Mengusung mesin 150cc DOHC 4 katup berpendingin cairan, CB150X memberikan performa responsif dengan kestabilan optimal untuk berbagai kondisi jalan.",
      },
      {
        type: "heading",
        text: "Desain Adventure Touring",
      },
      {
        type: "paragraph",
        text:
          "Tampilan adventure ditonjolkan melalui windshield tinggi, setang lebar, serta bodi kokoh yang mendukung kenyamanan saat touring maupun penggunaan harian.",
      },
      {
        type: "heading",
        text: "Stabil dan Aman di Berbagai Medan",
      },
      {
        type: "paragraph",
        text:
          "Suspensi depan Upside Down (USD), sistem pengereman ABS dual channel, serta Honda Selectable Torque Control (HSTC) memberikan kontrol maksimal di berbagai kondisi jalan.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      [
        "Tipe Mesin",
        "4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
      ],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "149,16 cc"],
      ["Daya Maksimum", "12,4 kW (16,9 PS) / 9.000 rpm"],
      ["Torsi Maksimum", "13,8 Nm / 7.000 rpm"],
      ["Transmisi", "Manual, 6 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Diamond Steel Frame"],
      ["Suspensi Depan", "Upside Down (USD)"],
      ["Suspensi Belakang", "Monoshock"],
      ["Rem Depan", "Cakram dengan ABS"],
      ["Rem Belakang", "Cakram dengan ABS"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "2.031 x 796 x 1.309 mm"],
      ["Tinggi Jok", "817 mm"],
      ["Jarak Sumbu Roda", "1.311 mm"],
      ["Berat", "139 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "12 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CB150X",
    items: [
      {
        title: "Mesin 150cc DOHC",
        desc:
          "Mesin bertenaga dengan karakter responsif yang siap digunakan untuk perjalanan jauh maupun harian.",
      },
      {
        title: "Upside Down Front Suspension",
        desc:
          "Suspensi depan USD yang meningkatkan kestabilan, kenyamanan, dan tampilan adventure.",
      },
      {
        title: "Dual Channel ABS",
        desc:
          "Sistem pengereman ABS depan dan belakang untuk keamanan maksimal di berbagai kondisi.",
      },
      {
        title: "Honda Selectable Torque Control (HSTC)",
        desc:
          "Fitur kontrol traksi untuk menjaga kestabilan roda belakang di jalan licin.",
      },
      {
        title: "Windshield Tinggi",
        desc:
          "Windshield depan yang membantu mengurangi terpaan angin saat perjalanan jauh.",
      },
      {
        title: "Full LED Lighting System",
        desc:
          "Sistem pencahayaan full LED dengan tampilan modern dan visibilitas optimal.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Panel meter digital informatif yang mendukung kebutuhan touring.",
      },
    ],
  },
};

export default cb150xData;
